export default __webpack_public_path__ + "static/media/image.destiny365-pvt-ltd.0ccc07ca.png";